import { Fragment, useEffect, useState } from 'react';

import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Paginator } from 'primereact/paginator';

import { TemplateInvoiceService as Service } from '../../../service/invoice/TemplateInvoiceService';
import { TypeInvoiceService } from '../../../service/invoice/TypeInvoiceService';

export const Create = () => {

  const [invoiceTypes, setInvoiceTypes] = useState([]);

  const [invoiceType, setInvoiceType] = useState(null);
  const [name, setName] = useState('');
  const [pageSize, setPageSize] = useState('A4');
  const [typeCompany, setTypeCompany] = useState(0);

  const pageSizes = [
    { value: 'A4', label: 'A4' },
    { value: 'A5', label: 'A5' },
    { value: 'A6', label: 'A6' },
    { value: 'A7', label: 'A7' }
  ];

  const typeCompanyOptions = [
    { value: 0, label: 'Thông thường' },
    { value: 1, label: 'Xăng dầu' },
    { value: 2, label: 'Vàng bạc' },
    { value: 3, label: 'Vé máy bay' },
    { value: 4, label: 'Mua bán xe' },
    { value: 5, label: 'Dịch vụ vận chuyển' },
    { value: 6, label: 'Dịch vụ vận chuyển trên nền tảng số' },
  ];

  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(4);

  const [totalRecords, setTotalRecords] = useState(0);
  const [items, setItems] = useState([]);

  useEffect(() => {
    TypeInvoiceService.getList({}).then(({ items }) => {
      if (items) {
        const _invoiceTypes = [{ value: null, label: '- Tất cả -' }];
        items.forEach((item) => {
          _invoiceTypes.push({ value: item.id, label: item.name });
        });
        setInvoiceTypes(_invoiceTypes);
        setInvoiceType(_invoiceTypes[1].value);
      }
    });
  }, []);

  useEffect(() => {
    loadTemplate();
  }, [first, rows, invoiceType]); // eslint-disable-line react-hooks/exhaustive-deps

  const onPageChange = (event) => {
    setFirst(event.first);
    setRows(event.rows);
  }

  const loadTemplate = () => {
    Service.getList({
      maxResultCount: rows,
      skipCount: first,
      typeInvoiceId: invoiceType,
      name,
      pageSize,
      typeCompany,
      sorting: 'code',
      sortType: 'ASCEND'
    }).then(({ totalCount, items }) => {
      setTotalRecords(totalCount);
      setItems(items);
    });
  }

  const back = () => {
    window.location.hash = '/phat-hanh/mau-hoa-don';
  }

  const windowHeight = window.innerHeight;

  return (
    <div className="mt-1 pl-3 pr-3 pt-2">
      <div className="grid iam-scroll" style={{ height: (windowHeight - 200) + 'px', overflow: 'hidden auto' }}>
        <div className="col-12 md:col-3">
          <div className="field p-fluid">
            <Dropdown value={invoiceType} options={invoiceTypes} onChange={e => setInvoiceType(e.value)} placeholder="Loại hoá đơn" />
          </div>
        </div>
        <div className="col-12 md:col-3">
          <div className="field p-fluid">
            <Dropdown value={typeCompany} options={typeCompanyOptions} onChange={e => setTypeCompany(e.value)} placeholder="Loại công ty" />
          </div>
        </div>
        <div className="col-12 md:col-3">
          <div className="field p-fluid">
            <InputText value={name} onChange={(e) => setName(e.target.value)} placeholder="Tên mẫu hóa đơn" />
          </div>
        </div>
        <div className="col-12 md:col-2">
          <div className="field p-fluid">
            <Dropdown value={pageSize} options={pageSizes} onChange={e => setPageSize(e.value)} placeholder="Khổ giấy" />
          </div>
        </div>
        <div className="col-12 md:col-1">
          <div className="field p-fluid">
            <Button icon="pi pi-search" onClick={loadTemplate} />
          </div>
        </div>

        {
          items.map((item, index) => {
            return (
              <div key={index} className="col-12 md:col-3 template-image-preview">
                <div className="card h-full">
                  <div><b>{item.name}</b></div>
                  <Preview id={item.id} invoiceType={invoiceType} />
                </div>
              </div>
            )
          })
        }
      </div>
      <div className="grid p-3 pb-0 card pt-0 mt-2">
        <div className="col-2 pt-4">
          <Button label="Quay lại" icon="pi pi-arrow-left" onClick={back} className="p-button-outlined p-button-secondary p-button-sm" />
        </div>
        <div className="col-8">
          <Paginator first={first} rows={rows} totalRecords={totalRecords} rowsPerPageOptions={[4, 8, 12]} onPageChange={onPageChange} />
        </div>
        <div className="col-2 pt-5 text-right">
          Tổng số {totalRecords} bản ghi
        </div>
      </div>
    </div>
  );
}

const Preview = ({ id, invoiceType }) => {

  const [content, setContent] = useState(null);

  useEffect(() => {
    if (id) {
      Service.get(id).then((data) => {
        if (data && data.imageContent) {
          setContent(data.imageContent);
        } else {
          setContent(null);
        }
      });
    } else {
      setContent(null);
    }
  }, [id]);

  const select = () => {
    if (id) {
      window.location.hash = `/phat-hanh/mau-hoa-don/create/${id}?invoiceType=${invoiceType}`;
    }
  }

  return (
    <Fragment>
      <div onClick={select}>
        {!content &&
          <i className="pi pi-image" />
        }
        {content &&
          <img src={`data:image/png;base64,${content}`} alt="" />
        }
      </div>
    </Fragment>
  );
}
